import { GA } from '@phoenix/core/frontend/shared/feature/google-analytics/ga';

const ADD_PRODUCT_EVENT_NAME = 'mystihl_add_product';
const ADD_PRODUCT_START_EVENT_NAME = 'mystihl_add_product_start';
const ADD_PRODUCT_ERROR_EVENT_NAME = 'mystihl_add_product_error';

type EventData = { type: 'stihl' | 'other_products' | 'registered'; text?: string };

const event = (name: string, eventData: EventData) => () => GA.sendEvent({ event_name: name, ...eventData }),
  withSerialNumberEventType = (name: string, data = {}) => event(name, { type: 'stihl', ...data }),
  otherProductsEventType = (name: string, data = {}) => event(name, { type: 'other_products', ...data }),
  registeredProductEventType = (name: string, data = {}) => event(name, { type: 'registered', ...data });

export const addToolStartEvent = {
  withSerialNumber: withSerialNumberEventType(ADD_PRODUCT_START_EVENT_NAME),
  otherProducts: otherProductsEventType(ADD_PRODUCT_START_EVENT_NAME),
  registeredProduct: registeredProductEventType(ADD_PRODUCT_START_EVENT_NAME),
};

export const addToolEvent = {
  withSerialNumber: withSerialNumberEventType(ADD_PRODUCT_EVENT_NAME),
  otherProducts: otherProductsEventType(ADD_PRODUCT_EVENT_NAME),
  registeredProduct: registeredProductEventType(ADD_PRODUCT_EVENT_NAME),
};

export const addToolErrorEvent = {
  alreadyRegisteredSameUser: withSerialNumberEventType(ADD_PRODUCT_ERROR_EVENT_NAME, { text: 'serial_used_same_client' }),
  alreadyRegisteredDifferentUser: withSerialNumberEventType(ADD_PRODUCT_ERROR_EVENT_NAME, { text: 'serial_used_different_client' }),
  invalidSerialNumber: withSerialNumberEventType(ADD_PRODUCT_ERROR_EVENT_NAME, { text: 'serial_unknown' }),
  registeredProductNotFound: registeredProductEventType(ADD_PRODUCT_ERROR_EVENT_NAME),
};
